import React from 'react';
import styled from 'styled-components';

const TagsContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
  margin-top: auto;
  overflow: hidden;
`;

const Tag = styled.span`
  background-color: #f6f6f6;
  color: #b1b1b1;
  padding: 0.25rem 0.5rem;
  border-radius: ${props => props.theme.borderRadius.base};
  font-size: ${props => props.theme.typography.xs};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex-shrink: 1;
`;

const MoreTag = styled(Tag)`
  flex-shrink: 0;
  max-width: none;
`;

export const Tags = ({
  tags = [],
  variant = 'article',
  maxTags = 3,
  showMore = true,
  className
}) => {
  if (!tags || tags.length === 0) return null;

  return (
    <TagsContainer className={className}>
      {tags.slice(0, maxTags).map((tag, index) => (
        <Tag key={index} variant={variant} data-cursor-text>
          {tag}
        </Tag>
      ))}
      {showMore && tags.length > maxTags && (
        <MoreTag variant={variant} data-cursor-text>
          +{tags.length - maxTags} more
        </MoreTag>
      )}
    </TagsContainer>
  );
};